export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9175.4a3224d5.jpg";